import { Box, LinearProgress, Typography } from '@mui/material';
import { useAnsweredPercentage } from '@/hooks/useAnsweredPercentage';

interface CompletionProgressProps {
  configId: number;
  /** 'full' → etichetta "Completata al X%" (card config); 'inline' → barra sottile (righe appartamento). */
  variant?: 'full' | 'inline';
}

/**
 * Barra di avanzamento della configurazione (percentuale milestone-based dal backend).
 * Mostra `Completata al X%` sopra una LinearProgress; indeterminata finché la % non è nota.
 */
export function CompletionProgress({ configId, variant = 'full' }: CompletionProgressProps) {
  const percentage = useAnsweredPercentage(configId);
  const known = percentage != null;
  const pct = known ? Math.round(percentage * 100) : 0;

  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mb: 0.25 }}
      >
        {known ? `Completata al ${pct}%` : 'Avanzamento…'}
      </Typography>
      <LinearProgress
        variant={known ? 'determinate' : 'indeterminate'}
        value={pct}
        aria-label={`Avanzamento configurazione ${known ? `${pct} percento` : 'in caricamento'}`}
        sx={{
          height: variant === 'inline' ? 4 : 6,
          borderRadius: 1,
          backgroundColor: 'divider',
        }}
      />
    </Box>
  );
}
